import { shadeColor } from './colors';

/** Anello di progresso con la percentuale di percorso in ombra. */
export function ShadeRing({
  frac,
  size = 84,
  stroke = 8,
}: {
  frac: number;
  size?: number;
  stroke?: number;
}) {
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  const f = Math.max(0, Math.min(1, frac));
  const pct = Math.round(f * 100);
  const half = size / 2;
  return (
    <div className="ring" style={{ width: size, height: size }} aria-label={`${pct}% in ombra`}>
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} aria-hidden="true">
        <circle cx={half} cy={half} r={r} className="ring__track" strokeWidth={stroke} />
        <circle
          cx={half}
          cy={half}
          r={r}
          className="ring__fill"
          strokeWidth={stroke}
          stroke={shadeColor(f)}
          strokeDasharray={`${c * f} ${c}`}
          strokeLinecap="round"
          transform={`rotate(-90 ${half} ${half})`}
        />
      </svg>
      <div className="ring__label">
        <span className="ring__value t-num">{pct}%</span>
        <span className="ring__cap">ombra</span>
      </div>
    </div>
  );
}
